import { z } from 'zod';

import { FannieMaeDelinquencyFileV1 } from '../investorReporting/FannieMae/FannieMaeDelinquencyFile';
import { FreddieMacEDRV1 } from '../investorReporting/FreddieMac/FreddieMacEDR';

export const NonPerformanceReason = z.enum([
  // Common to both Fannie Mae and Freddie Mac
  'Death of Borrower',
  'Illness of Borrower',
  "Illness of Borrower's Family Member",
  "Death of Borrower's Family Member",
  'Marital Difficulties',
  'Property Problem',
  'Inability to Sell Property',
  'Inability to Rent Property',
  'Military Service',
  'Other',
  'Unemployment',
  'Business Failure',
  'Casualty Loss',
  'Servicing Problems',
  'Payment Adjustment',
  'Payment Dispute',
  'Transfer of Ownership Pending',
  'Fraud',
  'Unable to Contact Borrower',
  'Incarceration',

  // included in Freddie Mac but not Fannie Mae
  'Curtailment of Income',
  'Excessive Obligations',
  'Abandonment of Property',
  'Distant Employment Transfer',
  'Energy‑Environment Cost',
  'National Emergency Declaration',
  'Eligible Disaster Area',
]);

export type NonPerformanceReason = z.infer<typeof NonPerformanceReason>;

export const NonPeformanceReasonToFannieMae: Record<
  NonPerformanceReason,
  FannieMaeDelinquencyFileV1['reasonForDelinquencyCode']
> = {
  'Death of Borrower': '001',
  'Illness of Borrower': '002',
  "Illness of Borrower's Family Member": '003',
  "Death of Borrower's Family Member": '004',
  'Marital Difficulties': '005',
  'Property Problem': '011',
  'Inability to Sell Property': '012',
  'Inability to Rent Property': '013',
  'Military Service': '014',
  Other: '015',
  Unemployment: '016',
  'Business Failure': '017',
  'Casualty Loss': '019',
  'Servicing Problems': '023',
  'Payment Adjustment': '026',
  'Payment Dispute': '027',
  'Transfer of Ownership Pending': '029',
  Fraud: '030',
  'Unable to Contact Borrower': '031',
  Incarceration: 'INC',

  // included in Freddie Mac but not Fannie Mae so we map to "Other"
  // TODO review these
  'Curtailment of Income': '015',
  'Excessive Obligations': '015',
  'Abandonment of Property': '015',
  'Distant Employment Transfer': '015',
  'Energy‑Environment Cost': '015',
  'National Emergency Declaration': '015',
  'Eligible Disaster Area': '015',
};

export const NonPerformanceReasonToFreddieMacEDR: Record<NonPerformanceReason, FreddieMacEDRV1['defaultReasonCode']> = {
  'Death of Borrower': '001',
  'Illness of Borrower': '002',
  "Illness of Borrower's Family Member": '003',
  "Death of Borrower's Family Member": '004',
  'Marital Difficulties': '005',
  'Curtailment of Income': '006',
  'Excessive Obligations': '007',
  'Abandonment of Property': '008',
  'Distant Employment Transfer': '009',
  'Property Problem': '011',
  'Inability to Sell Property': '012',
  'Inability to Rent Property': '013',
  'Military Service': '014',
  Other: '015',
  Unemployment: '016',
  'Business Failure': '017',
  'Casualty Loss': '019',
  'Energy‑Environment Cost': '022',
  'Servicing Problems': '023',
  'Payment Adjustment': '026',
  'Payment Dispute': '027',
  'Transfer of Ownership Pending': '029',
  Fraud: '030',
  'Unable to Contact Borrower': '031',
  'National Emergency Declaration': '032',
  'Eligible Disaster Area': '034',
  Incarceration: 'INC',
};
